import React, { useState } from 'react';

import Header from '../shared/components/Header';
import { Link } from "react-router-dom";
import SerializeClass from '../shared/Utils/serialized';
import HttpCall from '../api/Http';
import { useNavigate } from "react-router-dom";
import validator from 'validator'
import Alert from '../shared/Utils/AlertBox';
import Loader from '../shared/components/Loader';

export default function SignUp() {
    const [firstName, setFirstName] = useState('');
    const [lasttName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [terms, setTerms] = useState(false);
    const [loader, setLoader] = useState(false);


    const navigate = useNavigate();

    function signup(e) {

        e.preventDefault();

        if (!firstName || !lasttName) {
            return Alert.show('Error','Please enter the required Field','error')
        }
        if (!validator.isEmail(email)) {
            return Alert.show('Error','Please enter the valid email','error')
        }
        if (password.length<6) {
            return Alert.show('Error','Minimum 6 character password is required','error')
        }
        if(!terms) {
            return Alert.show('Error','Please accept Privacy Policy and Terms & Conditions','error')
        }

        let requestData = new FormData();
        requestData.append('User_Name', firstName + ' ' + lasttName);
        requestData.append('First_Name', firstName);
        requestData.append('Last_Name', lasttName);
        requestData.append('lasttName', lasttName);
        requestData.append('Email', email);
        requestData.append('Phone_Number', '1234567');
        requestData.append('Password', password);
        requestData.append('Profile_Picture', '');
        requestData.append('Device_Id', '');
        requestData.append('CNIC', '');
        requestData.append('Gender_Id', 1);
        setLoader(true);
        HttpCall.postRequest(`/User/api/auth/signup/`,requestData).then(response => {
            setLoader(false);
            if(response.data.code==200) {
                let user = response.data.data;
                if(user.length>0) {
                    localStorage.setItem('user', JSON.stringify(user));
                    localStorage.setItem('isLoggedIn', '1');
                    navigate('/dashboard');
                }
            } else {
                return Alert.show('Error',response.data.msg,'error')
            }
        }).catch(err => {
            setLoader(false);
            console.log(err);
        })
    }

    return (
        <>
        <Header />
        <div className="basic-1 margin-top">
        {loader && <Loader />}
        <div className="container">
            <div className="row">
                <div className="col-lg-6">
                    <div className="text-container no-margin-top">
                        <h2>Sign Up & Plan Your Business Growth Steps</h2>
                        
                    <div className="form-container">
                        <form id="requestForm" data-toggle="validator" data-focus="false">
                            
                        <div className="row">
                            <div className="col-lg-6" style={{paddingRight:'8px'}}>
                                <div className="form-group customlogin">
                                <input type="text" className="form-control-input" id="rname" 
                                onChange={e => setFirstName(e.target.value.replace(/[^a-z]/gi, ''))}
                                name="rname" required value={firstName}/>
                                <label className="label-control" htmlFor="rname">First name</label>
                                <div className="help-block with-errors"></div>
                            </div>
                            </div>
                            
                            <div className="col-lg-6" style={{paddingRight:'8px'}}>
                                 <div className="form-group customlogin">
                                    <input type="text" className="form-control-input" id="rname" 
                                    onChange={e => setLastName(e.target.value.replace(/[^a-z]/gi, ''))}
                                    name="rname" required value={lasttName}/>
                                <label className="label-control" htmlFor="rname">Last name</label>
                                <div className="help-block with-errors"></div>
                            </div>
                            </div>
                            </div>

                            <div className="form-group customlogin">
                                <input type="email" className="form-control-input" id="remail" 
                                onChange={e => setEmail(e.target.value)}
                                name="remail" required />
                                <label className="label-control" htmlFor="remail">Email</label>
                                <div className="help-block with-errors"></div>
                            </div>
                            <div className="form-group customlogin">
                                <input type="password" className="form-control-input" id="remail"
                                onChange={e => setPassword(e.target.value)} 
                                name="remail" required />
                                <label className="label-control" htmlFor="remail">Password</label>
                                <div className="help-block with-errors"></div>
                            </div>
                            <div className="form-group checkbox">
                                <input type="checkbox" id="rterms" checked={terms} onChange={(e) => { setTerms(!terms)}} name="terms" required />I agree with Getbound.ai stated <a href="privacy-policy.html">Privacy Policy</a> and <a href="terms-conditions.html">Terms & Conditions</a>
                                <div className="help-block with-errors"></div>
                            </div>
                            <div className="form-group">
                                <button type="submit" className="form-control-submit-button"
                                 onClick={signup}>SIGN UP</button>
                            </div>
                            <div className="form-message">
                                <div id="rmsgSubmit" className="h3 text-center hidden"></div>
                            </div>
                        </form>
                    </div>
                <div className="signupbtn">
                    {/* <a className="turquoise" href="login.html">Already have an account?</a> */}
                    <Link to="/" className="turquoise">Already have an account?</Link>

                </div>
                
            </div>
                </div>
                <div className="col-lg-6">
                    <div className="image-container">
                        <img className="img-fluid" src={process.env.PUBLIC_URL + 'assets/images/details-1-office-worker.svg'} alt="alternative" />
                    </div> 
                </div>
            </div>
        </div>
    </div>
    <div class="copyright">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <p class="p-small">Copyright © 2023 <a href="https://getbound.ai/">Getbound.ai</a> - All rights reserved</p>
                </div> 
            </div> 
        </div> 
    </div>
    </>
    )
}